/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

export function TextView(props) {
  const { em, data } = props;
  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row') + ' ' + (em.class ? em.class : '');
  const labelClass = floating ? 'd-block' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const suffixClass = `col-sm-2`;
  let inputClass = (floating ? 'd-block' : `col-sm-${parentSize === 'full' ? '10' : '7'}`) + ' col-form-label';
  if (!em.label && !em.suffix) inputClass = `col-sm-12 col-form-label`;
  if (em.suffix) {
    inputClass = floating ? 'col-sm-10' : `col-sm-${parentSize === 'full' ? '8' : '5'}`;
    inputClass += ` col-form-label`;
  }
  if (em.align && em.align !== '') inputClass += ` text-${em.align}`;

  let _formattedText = (props.data && em.field && props.data[em.field]) || '';

  // See sample in table-grid.js for function value
  if (em?.field?.substring(0, 1) === '@') {
    const t = em.field;
    const s = t.substring(1).split(':');
    const fx = [t, ...s];
    if (fx) {
      if (typeof props.app[fx[1]] !== 'function') {
        // if (!props.app.disableTableGridError) {
          console.error(`${fx[1]} from ${t} is not function`, props.app);
        // }
        return null;
      }

      let _data = data[fx[2]];
      if (fx[3] && data[fx[3]]) {
        _data = {};
        _data[fx[2]] = data[fx[2]];
        _data[fx[3]] = data[fx[3]];
      }

      // support static append text
      if (fx[3] && !data[fx[3]]) {
        _data = {};
        _data[fx[2]] = data[fx[2]];
        _data.append = fx[3];
      }

      _formattedText = props.app[fx[1]](fx[2] === '?' ? data : _data || '');
    }
  }

  if (em.format && em.format.type) {
    switch (em.format.type) {
      case 'number': {
        const options = em.format.options || {};
        if (em.format.digits) {
          options.minimumFractionDigits = em.format.digits;
          options.maximumFractionDigits = em.format.digits;
        }
        _formattedText = new Intl.NumberFormat('en-US', options).format(+_formattedText);
        break;
      }

      case 'date': {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        const dateFmt = new Intl.DateTimeFormat(props.locale || 'en-UK', em.format.options || options);
        try {
          _formattedText = _formattedText !== '' ? dateFmt.format(new Date(_formattedText)) : '';
        } catch(ex) {
          console.info(`Invalid Date: ${_formattedText}`);
        }
        break;
      }

      default:
        break;
    }
  }

  if (em.append) {
    if (props.data && props.data[em.append]) {
      _formattedText += ` ${props.data[em.append]}`;
    } else {
      _formattedText += ` ${em.append}`;
    }
  }

  if (floating) {
    return (
      <div className={`form-group ${groupClass}`}>
        {em && em.label && <small className={`${labelClass}`}>{em.label}</small>}
        <label className={`${inputClass}`}>
          {_formattedText}
          {em && em.suffix && ` ${em.suffix}`}
          <br />
        </label>
      </div>
    );
  } else {
    return (
      <div className={`form-group ${groupClass}`}>
        {em && em.label && <label className={`${labelClass}`}>{em.label}</label>}
        <label className={`${inputClass}`}>{_formattedText}{em && em.suffix && ` ${em.suffix}`}</label>
      </div>
    );
  }
}

TextView.defaultProps = {
  em: {}, // parentSize: 'half'
};

TextView.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any,
  parent: PropTypes.any,
  size: PropTypes.string,
  locale: PropTypes.any,
}